import React from 'react';
export const SchemaContext = React.createContext({ site: '99designs.com' });
